import { useEffect, useState, useMemo } from "react";
import Skeleton from "react-loading-skeleton";
import { searchAdoptablePets } from "./service";
import { Carousel } from "./Carousel.tsx";
import { PetSummary } from "./types.ts";
import AdoptablePetPreview from "./AdoptablePetPreview.tsx";
import PetFilterControls from "./filters/PetFilterControls.tsx";
import {usePetFilterControls} from "./filters/usePetFilterControls.ts";
import NoPetsFound from "./NoPetsFound.tsx";

export function AdoptablePetsFilterableCarouselWrapper({ params }: any) {
  const [petSummaries, setPetSummaries] = useState<PetSummary[] | undefined>(
    undefined,
  );

  useEffect(() => {
    (async () => {
      setPetSummaries(undefined);
      const result = await searchAdoptablePets(params);
      setPetSummaries(result);
    })();
  }, [params]);

  if (petSummaries === undefined) {
    return <Skeleton count={5} />;
  }

  if (petSummaries.length === 0) {
    return (
      <div className="text-center text-2xl font-bold">
        No pets in this category are currently available for adoption.
      </div>
    );
  }

  return <FilterablePetCarousel petSummaries={petSummaries} />;
}

type AdoptablePetsCarouselProps = {
  petSummaries: PetSummary[];
};

function FilterablePetCarousel({ petSummaries }: AdoptablePetsCarouselProps) {
  const { filteredPets, petFilterControlsProps } = usePetFilterControls({
    petSummaries,
  });

  const slides = useMemo(() => {
    return filteredPets.map((pet, index) => (
      <AdoptablePetPreview key={index} item={pet} />
    ));
  }, [filteredPets]);

  return (
    <section className="mx-auto">
      <PetFilterControls {...petFilterControlsProps} />
      {
        slides.length === 0 ? (
            <NoPetsFound/>
        )
          :<Carousel slides={slides} />
      }

    </section>
  );
}
